import { render, staticRenderFns } from "./Shipyard.vue?vue&type=template&id=e40c0516&scoped=true"
import script from "./Shipyard.vue?vue&type=script&lang=js"
export * from "./Shipyard.vue?vue&type=script&lang=js"
import style0 from "./Shipyard.vue?vue&type=style&index=0&id=e40c0516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40c0516",
  null
  
)

export default component.exports